// extracted by mini-css-extract-plugin
module.exports = {"comp":"JF_comp__wXW0U"};